export const messages = {
  contactUs: 'Contact Us',
  teamWillGetBackToYou: 'Our expert team will get back to you',

  firstNameLabel: 'First Name',
  firstName: 'firstName',
  firstNameRequired: 'First Name is required',
  lastNameLabel: 'Last Name',
  lastName: 'lastName',
  lastNameRequired: 'Last Name is required',
  phoneLabel: 'Phone',
  phone: 'phone',
  phoneNumberRequired: 'Phone Number is required',
  phoneNumberValid: 'Please Enter a valid Phone Number',
  emailLabel: 'Email',
  email: 'email',
  emailRequired: 'Email is required',

  selectSubjectLabel: 'Select Subject?',
  selectSubject: 'selectSubject',
  subjectRequired: 'Please Select A Subject',
  generalInquiry: 'General Inquiry',
  homeLoan: 'Home Loan',
  carLoan: 'Car Loan',
  others: 'Others',

  writeYourMessage: 'Write your message...',
  enterYourMessage: 'Please Enter Your Message...',

  sendMessage: 'Send Message',
  updateMessage: 'Update Message',

  //Business contact
  businessContactInfo: 'Contact Information',
  readyToHelp: 'Our dedicated team is ready to help you',
  businessPhoneNumber: '1-646-780-9673',
  businessEmail: 'info@cashclever.net',
  businessAddress: '2 University Plaza, Suite 100 Hackensack, NJ 07601',
  mapsUrl: 'https://maps.app.goo.gl/GaAPmnZaQQeae3M37',
  messageSent: 'Message Sent!',
  willContact: 'Our team will contact you soon. Stay tuned!',
  thankYou: 'Thank You',
  thankYouMessage: 'Your message was sent successfully.',
  thankYouMessage2: 'We will contact you through email.',
  goBack: 'Go back',
};
